import { getNumberFromFilterPrimitive, getNumberFromConfidence } from '../..';

export const preFilterTypes: Record<PreFilterType, PreFilterPredicate> = {
    equals: (
        filter: PreFilterPrimitive,
        field: PreFilterPrimitive,
    ): boolean => {
        if (typeof filter === 'string' && typeof field === 'string') {
            // Ignore leading and trailing spaces and casing when comparing strings
            return filter.trim().toLowerCase() === field.trim().toLowerCase();
        }

        return filter === field;
    },
    lessThanOrEqualTo: (
        filter: PreFilterPrimitive,
        field: PreFilterPrimitive,
    ): boolean => {
        const filterNumber = getNumberFromFilterPrimitive(
            filter,
            Number.MAX_SAFE_INTEGER,
        );
        const fieldNumber = getNumberFromFilterPrimitive(
            field,
            Number.MAX_SAFE_INTEGER,
        );

        if (
            fieldNumber === Number.MAX_SAFE_INTEGER &&
            filterNumber === Number.MAX_SAFE_INTEGER
        ) {
            return true;
        }

        return fieldNumber <= filterNumber;
    },
    greaterThanOrEqualTo: (
        filter: PreFilterPrimitive,
        field: PreFilterPrimitive,
    ): boolean => {
        const filterNumber = getNumberFromFilterPrimitive(
            filter,
            Number.MAX_SAFE_INTEGER,
        );
        const fieldNumber = getNumberFromFilterPrimitive(
            field,
            -Number.MAX_SAFE_INTEGER,
        );

        if (
            fieldNumber === -Number.MAX_SAFE_INTEGER &&
            filterNumber === -Number.MAX_SAFE_INTEGER
        ) {
            return true;
        }

        return fieldNumber >= filterNumber;
    },
    greaterThan: (
        filter: PreFilterPrimitive,
        field: PreFilterPrimitive,
    ): boolean => {
        const filterNumber = getNumberFromFilterPrimitive(
            filter,
            Number.MAX_SAFE_INTEGER,
        );
        const fieldNumber = getNumberFromFilterPrimitive(
            field,
            -Number.MAX_SAFE_INTEGER,
        );

        if (
            fieldNumber === -Number.MAX_SAFE_INTEGER &&
            filterNumber === -Number.MAX_SAFE_INTEGER
        ) {
            return true;
        }

        return fieldNumber > filterNumber;
    },
    confidenceGreaterThanOrEqualTo: (
        filter: PreFilterPrimitive,
        field: PreFilterPrimitive,
    ): boolean => {
        const filterNumber = getNumberFromConfidence(
            filter,
            Number.MAX_SAFE_INTEGER,
        );
        const fieldNumber = getNumberFromConfidence(
            field,
            -Number.MAX_SAFE_INTEGER,
        );

        if (
            fieldNumber === -Number.MAX_SAFE_INTEGER &&
            filterNumber === -Number.MAX_SAFE_INTEGER
        ) {
            return true;
        }

        return fieldNumber >= filterNumber;
    },
};
